import React from 'react';
import { withRouter } from 'react-router-dom';
import FeatureFlag from 'components/shared/FeatureFlag';

import LearnHeader from './LearnHeader';
import ConnectedWelcomeLearnHeader from './WelcomeLearnHeader';

const Header = ({ expert, features }) => (
  <FeatureFlag features={['certifications']} fallback={<LearnHeader />}>
    <ConnectedWelcomeLearnHeader />
  </FeatureFlag>
);

// notify the connected Header component of any location changes coming from
// the router. Otherwise, the connected Header will block re-rendering when the
// location changes.
export default withRouter(Header);
